import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../../../Components/comman/Header";
import SideMenu from "../SideMenu";
import { Form, Tab, InputGroup, FormControl, Button } from "react-bootstrap";
import Select from "react-select";
import { components } from "react-select";
import customStyles from "../../../Components/SelectCustomStyles";
import tableData from "../../../Components/TableData";
import { Tooltip } from "react-tooltip";
import {
  BsFillInfoCircleFill,
  BsCloudUploadFill,
  BsUpload,
} from "react-icons/bs";
import "react-country-state-city/dist/react-country-state-city.css";
import { Notification, toaster, Uploader } from "rsuite";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import Images from "../../../Helpers/Images";
import MobileHeader from "../../../Components/comman/MobileHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Auth } from "../../../Contexts/AuthContext";
const EditCampign = () => {
  const location = useLocation();
  const campaignDetails = location?.state?.item;
  let { id } = useParams();
  const navigate = useNavigate();
  const { auth } = useContext(Auth);
  const [heroPreview, setHeroPreview] = useState("");
  const { MultiValue, Option } = components;
  const [fileInfo, setFileInfo] = useState(null);
  const [campaignData, setCampaignData] = useState({});
  const [galleryImages, setGalleryImages] = useState([]);
  const [inspritionImages, setInspritionImages] = useState([]);
  const [campaignFormData, setCampaignFormData] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [contentFormatCounts, setContentFormatCounts] = useState({
    igtv: "",
    post: "",
    reel: "",
    story: "",
    video: "",
    shorts: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [activeMenu, setActiveMenu] = useState("general");
  const general = useRef(null);
  const compensation = useRef(null);
  const requirnment = useRef(null);
  const deliverables = useRef(null);
  const [removedGalleryImages, setRemovedGalleryImages] = useState([]);
  const [removedInspirationImages, setRemovedInspirationImages] = useState([]);

  useEffect(() => {
    getcategories();
  }, []);
  console.log("campaignDetails", campaignDetails);
  const backendHeroUrl = campaignDetails?.campaign_logo_url || "";
  useEffect(() => {
    if (!campaignDetails) return;
    if (backendHeroUrl) {
      setFileInfo({
        name: backendHeroUrl.split("/").pop(),
        fileKey: "hero-existing",
        status: "done",
        url: backendHeroUrl,
      });
      setHeroPreview(backendHeroUrl);
    } else {
      setFileInfo(null);
      setHeroPreview("");
    }
    const format = campaignDetails?.content_format || {};
    setContentFormatCounts({
      video: format.video || "",
      shorts: format.shorts || "",
      story: format.story || "",
      igtv: format.igtv || "",
      reel: format.reel || "",
      post: format.post || "",
    });
    const payment = campaignDetails?.paid_campaign_payment;
    const preSelectedCategories =
      campaignData?.categories_list?.filter((option) =>
        campaignDetails?.categories?.some((cat) => cat.id === option.value)
      ) || [];
    setSelectedCategories(preSelectedCategories);
    setCampaignFormData({
      ...campaignDetails,
      retail_value: campaignDetails?.retail_value || { type: "fixed" },
      paid_campaign_payment: payment
        ? payment.type === "fixed"
          ? { type: "fixed", value: payment.value || "" }
          : { type: "range", value: payment.value || { min: "", max: "" } }
        : { type: "fixed", value: "" },
      campaign_title: campaignDetails?.campaign_title || "",
      hero_image: backendHeroUrl,
      campaign_strategy: campaignDetails?.campaign_strategy_details?.id || null,
      creditCardHold: campaignDetails?.credit_card_hold == 1 ? true : false,
      location_id: campaignDetails?.countries?.map((item) => item.id) || [],
      category_id: campaignDetails?.categories?.map((item) => item.id) || [],
      category_name:
        campaignDetails?.categories?.map((item) => item.name) || [],
    });
  }, [campaignDetails, campaignData]);
  const scrollToSection = (sectionRef) => {
    sectionRef.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
      inline: "nearest",
    });

    setActiveMenu(sectionRef);
  };
  const IconSingleValue = (props) => (
    <MultiValue {...props}>
      <img
        src={props.data.icon}
        style={{
          height: "20px",
          width: "20px",
          borderRadius: "50%",
          marginRight: "10px",
        }}
      />
      {props.data.label}
    </MultiValue>
  );
  const IconSingleValueCountry = (props) => (
    <MultiValue {...props}>{props.data.name}</MultiValue>
  );
  const IconOption = (props) => (
    <Option {...props}>
      <img
        src={props.data.icon}
        style={{ height: "20px", width: "20px", marginRight: "10px" }}
      />
      {props.data.label}
    </Option>
  );
  const CountryOption = (props) => (
    <Option {...props}>{props.data.name}</Option>
  );
  const handleOnChange = (name, value) => {
    setCampaignFormData({ ...campaignFormData, [name]: value });
  };
  // getting categories from api
  const getcategories = () => {
    let config = {
      url: ApiUrl.getCampaignCreationData,
      method: "GET",
    };
    APIRequest(
      config,
      (res) => {
        setCampaignData(res?.data);
        setIsLoading(false);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
      }
    );
  };

  const previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };
  const handleHeroUpload = ({ file: serverFileName, key: fileKey }) => {
    setCampaignFormData((prev) => ({
      ...prev,
      campaignLogo: serverFileName,
      hero_image: heroPreview || prev.hero_image,
    }));
    setFileInfo({
      name: serverFileName,
      fileKey,
      url: heroPreview,
      status: "done",
    });
  };
  const onRemoveHeroFile = () => {
    setHeroPreview("");

    setCampaignFormData((prev) => ({
      ...prev,
      campaignLogo: "",
      hero_image: "",
    }));

    setFileInfo(null);
    return true;
  };

  const heroDefaultFileList = campaignDetails?.campaign_logo_url
    ? [
        {
          name: campaignDetails.campaign_logo_url.split("/").pop(),
          fileKey: "hero-existing",
          status: "finished",
          url: campaignDetails.campaign_logo_url,
        },
      ]
    : [];
  const galleryDefaultFileList =
    campaignDetails?.gallery?.map((item, index) => ({
      name: item.image_url?.split("/").pop(),
      fileKey: `gallery-${item.id || index}`,
      status: "finished",
      url: item.image_url,
    })) || [];

  const onGallerySuccess = (response, file) => {
    const newItem = {
      file: response?.file,
      fileKey: file?.fileKey,
      name: response?.file?.split("/").pop() || file?.name || "gallery",
      status: "finished",
      url: response?.file,
    };
    setGalleryImages((prev) => [...(prev || []), newItem]);
  };
  const onRemoveGalleryFile = (file) => {
    const key = file?.fileKey ?? file?.key ?? file?.keyfile;

    // Check if this is an existing file from backend
    const isExistingFile = galleryDefaultFileList.some(
      (item) => item.fileKey === key
    );

    if (isExistingFile) {
      // Track removed backend files
      setRemovedGalleryImages((prev) => [...prev, file.url || file.name]);
    }

    const remainingImages = (galleryImages || []).filter(
      (item) => item.fileKey !== key
    );
    setGalleryImages(remainingImages);
    return true;
  };
  const onRemoveInspirationFile = (file) => {
    const key = file?.fileKey ?? file?.key ?? file?.keyfile;

    // Check if this is an existing file from backend
    const isExistingFile = inspirationDefaultList.some(
      (item) => item.fileKey === key
    );

    if (isExistingFile) {
      // Track removed backend files
      setRemovedInspirationImages((prev) => [...prev, file.url || file.name]);
    }

    const remainingFiles = (inspritionImages || []).filter(
      (item) => item.fileKey !== key
    );

    setInspritionImages(remainingFiles);
    setCampaignFormData((prev) => ({
      ...prev,
      inspiration_board: remainingFiles,
    }));

    return true;
  };
  const onInspirationSuccess = (response, file) => {
    const uploadedFile = {
      file: response?.file,
      fileKey: file?.fileKey,
      name: response?.file?.split("/").pop() || file?.name || "asset",
      status: "finished",
      url: response?.file,
    };
    setInspritionImages((prev) => [...(prev || []), uploadedFile]);
    setCampaignFormData((prev) => ({
      ...prev,
      inspiration_board: [...(prev?.inspiration_board || []), uploadedFile],
    }));
  };

  const inspirationDefaultList = (campaignDetails?.inspiration_board || []).map(
    (fileName, index) => ({
      name: fileName,
      fileKey: `insp-${index}`,
      status: "finished",
      url: fileName,
    })
  );
  const handleSubmit = async () => {
    const existingGallery =
      campaignFormData?.gallery
        ?.filter((item) => !removedGalleryImages.includes(item.image_url))
        ?.map((item) => item.image_url) || [];
    const existingInspiration = (
      campaignFormData?.inspiration_board || []
    ).filter((fileName) => !removedInspirationImages.includes(fileName));
    let config = {
      url: ApiUrl.newCampaign,
      method: "POST",
      body: {
        ...campaignFormData,
        campaignLogo: campaignFormData?.campaignLogo
          ? campaignFormData?.campaignLogo
          : campaignFormData.campaign_logo_url,
        content_format: contentFormatCounts,
        gallery: [
          ...existingGallery,
          ...(galleryImages?.map((item) => item.file) || []),
        ],
        inspiration_board: [
          ...existingInspiration,
          ...(inspritionImages?.map((item) => item.file) || []),
        ],
        social_channels: campaignFormData?.campaign_platform?.map(
          (item) => item.id
        ),
        id: campaignFormData?.id,
        campaign_title: campaignFormData?.campaign_title,
      },
    };
    console.log("what i am sending to api", config);
    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        toaster.push(
          <Notification type="success" header="success" closable>
            {res?.message}
          </Notification>,
          {
            placement: "topCenter",
          }
        );
        navigate("/brand/campaigns", { replace: true });
      },
      (err) => {
        if (err?.response?.status === 422) {
          console.log("error++", err?.response?.data?.message);
          toaster.push(
            <Notification type="error" header="error" closable>
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        } else if (err.response.status === 401) {
          toaster.push(
            <Notification type="error" header="error" closable>
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        }
        setIsLoading(false);
      }
    );
  };
  const getSocialPlatform = (item) => {
    const findItem = campaignData?.social_platForms_list?.find(
      (s) => s.value == item
    );
    if (findItem != undefined) return findItem;
    return {};
  };
  const getSocialPlatformbyName = (platform) => {
    const findItem = campaignFormData?.campaign_platform?.find(
      (item) => item.name.toUpperCase() == platform.toUpperCase()
    );
    if (findItem != undefined) return true;
    return false;
  };
  const calculateEngagementSummary = () => {
    const platforms = campaignFormData?.campaign_platform || [];
    const followerValues = platforms
      .map((p) => Number(p?.social_engagement_data?.follower))
      .filter((v) => !isNaN(v));
    const engagementValues = platforms
      .map((p) => Number(p?.social_engagement_data?.engagement))
      .filter((v) => !isNaN(v));
    const ageMin = campaignFormData?.age?.min;
    const ageMax = campaignFormData?.age?.max;
    let ageRange = "-";
    if (ageMin || ageMax) {
      ageRange = `${ageMin || 13} - ${ageMax || "+"}`;
    }
    const selectedCountryNames =
      campaignFormData?.location_id?.length > 0
        ? campaignData?.loactions
            ?.filter((loc) => campaignFormData.location_id.includes(loc.id))
            .map((loc) => loc.name.substring(0, 3).toUpperCase())
            .join(", ")
        : "-";
    const selectedNicheNames =
      campaignFormData?.category_id?.length > 0
        ? campaignData?.categories_list
            ?.filter((cat) => campaignFormData.category_id.includes(cat.value))
            .map((cat) => cat.label)
            .join(", ")
        : "-";
    return {
      follower:
        followerValues.length > 0
          ? `${Math.min(...followerValues)} - ${Math.max(...followerValues)}+`
          : "-",
      engagement:
        engagementValues.length > 0
          ? `${Math.min(...engagementValues)} - ${Math.max(
              ...engagementValues
            )}+`
          : "-",
      age: ageRange,
      countries: selectedCountryNames,
      niche: selectedNicheNames,
    };
  };
  const summary = calculateEngagementSummary();
  return (
    <div className="brand-dashboard-wrapper">
      <Header />
      <MobileHeader />
      <div className="brand-dashboard-inner ">
        <Tab.Container activeKey={`campaigns`}>
          <SideMenu />
          <div className="brand-dashboard-content-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"campaigns"}>
                <div className="create-campagin-wrapper">
                  <div className="campagin-builder-wrapper">
                    <div className="builder-inner">
                      <h6 className="heading-title">Campaign Builder</h6>
                      <div ref={general} className="general-box box">
                        <h4 className="section-heading">General</h4>
                        <Form>
                          {/* campaign title */}
                          <Form.Group controlId="formInput" className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                              type="text"
                              value={campaignFormData?.campaign_title || ""}
                              onChange={(e) =>
                                handleOnChange("campaign_title", e.target.value)
                              }
                            />
                          </Form.Group>
                          {/* Campaign Strategy */}
                          <Form.Group controlId="formSelect1" className="mb-3">
                            <Form.Label>Campaign Strategy</Form.Label>
                            <Select
                              options={campaignData?.CampaignStrategy?.map(
                                (item) => ({ label: item.name, value: item.id })
                              )}
                              placeholder={"Select"}
                              styles={customStyles}
                              onChange={(value) => {
                                handleOnChange(
                                  "campaign_strategy",
                                  value.value
                                );
                              }}
                              value={
                                campaignData?.CampaignStrategy?.map((item) => ({
                                  label: item.name,
                                  value: item.id,
                                }))?.find(
                                  (opt) =>
                                    opt.value ===
                                    campaignFormData.campaign_strategy
                                ) || null
                              }
                            />
                          </Form.Group>
                          {/* starategy detail table */}
                          <div className="table-container">
                            <table>
                              <thead>
                                <tr>
                                  <th>Type</th>
                                  <th>Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tableData.map((row, index) => (
                                  <tr key={index}>
                                    <td className="type">{row.type}</td>
                                    <td>{row.description}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          {/* social channels */}
                          {campaignFormData?.campaign_strategy !== 1 && (
                            <Form.Group
                              controlId="formSelect2"
                              className="mb-2"
                            >
                              <Form.Label>Social Channel(s)</Form.Label>
                              <Select
                                options={campaignData?.social_platForms_list}
                                placeholder="Select"
                                styles={customStyles}
                                isMulti
                                components={{
                                  MultiValue: IconSingleValue,
                                  Option: IconOption,
                                }}
                                value={
                                  campaignFormData?.campaign_platform?.map(
                                    (item) => ({
                                      label: item.name,
                                      value: item.id,
                                      icon: item.logo,
                                    })
                                  ) || []
                                }
                                onChange={(selectedOptions) => {
                                  handleOnChange(
                                    "social_channels",
                                    selectedOptions?.map((opt) => opt.value)
                                  );
                                  const updatedPlatforms = selectedOptions?.map(
                                    (opt) => ({
                                      id: opt.value,
                                      name: opt.label,
                                      logo: opt.icon,
                                      social_engagement_data: {
                                        follower: "",
                                        engagement: "",
                                      },
                                    })
                                  );

                                  handleOnChange(
                                    "campaign_platform",
                                    updatedPlatforms
                                  );
                                }}
                              />
                            </Form.Group>
                          )}
                        </Form>
                      </div>
                      <div ref={compensation} className="compensation-box box">
                        <h4 className="section-heading">Compensation</h4>
                        <p>
                          Enter details about your campaign and the product to
                          be promoted.
                        </p>
                        <div className="inner-content">
                          {/* retail box */}
                          <div className="retail-box">
                            <div className="head">
                              <a
                                data-tooltip-id="tooltip"
                                data-tooltip-content="To ensure you have plenty of creators to choose from, we recommend at least $20 in product or service value for every 1k in the required followers you set."
                              >
                                <BsFillInfoCircleFill />
                              </a>
                              <Tooltip id="tooltip" place="top" />
                              <h6>
                                Retail Value
                                <span> (of your product or service)</span>
                              </h6>
                            </div>
                            <Form>
                              <Form.Check
                                type="radio"
                                id="fixed"
                                name="priceType"
                                label="Fixed"
                                checked={
                                  campaignFormData?.retail_value?.type ===
                                  "fixed"
                                }
                                onChange={() => {
                                  handleOnChange("retail_value", {
                                    ...campaignFormData?.retail_value,
                                    type: "fixed",
                                    value: "",
                                  });
                                }}
                              />
                              <Form.Check
                                type="radio"
                                id="range"
                                name="priceType"
                                label="Range"
                                checked={
                                  campaignFormData?.retail_value?.type ===
                                  "range"
                                }
                                onChange={() => {
                                  handleOnChange("retail_value", {
                                    ...campaignFormData?.retail_value,
                                    type: "range",
                                    value: {},
                                  });
                                }}
                              />
                              {campaignFormData?.retail_value?.type ===
                              "fixed" ? (
                                <Form.Group
                                  controlId="formFixedValue"
                                  className="mt-2"
                                >
                                  <InputGroup>
                                    <InputGroup.Text>$</InputGroup.Text>
                                    <FormControl
                                      type="number"
                                      value={
                                        campaignFormData?.retail_value?.value ??
                                        ""
                                      }
                                      onChange={(e) => {
                                        handleOnChange("retail_value", {
                                          ...campaignFormData?.retail_value,
                                          value: e.target.value,
                                        });
                                      }}
                                    />
                                  </InputGroup>
                                </Form.Group>
                              ) : (
                                <div className=" mt-2 range-input">
                                  <Form.Group controlId="formRangeMinValue">
                                    <InputGroup>
                                      <InputGroup.Text>Min $</InputGroup.Text>
                                      <FormControl
                                        type="number"
                                        min="0"
                                        value={
                                          campaignFormData?.retail_value?.value
                                            ?.min ?? ""
                                        }
                                        onChange={(e) => {
                                          handleOnChange("retail_value", {
                                            ...campaignFormData?.retail_value,
                                            value: {
                                              ...campaignFormData?.retail_value
                                                ?.value,
                                              min: e.target.value,
                                            },
                                          });
                                        }}
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                  <Form.Group
                                    controlId="formRangeMaxValue"
                                    className=""
                                  >
                                    <InputGroup>
                                      <InputGroup.Text>Max $</InputGroup.Text>
                                      <FormControl
                                        type="number"
                                        min={
                                          campaignFormData?.retail_value?.value
                                            ?.min
                                            ? parseFloat(
                                                campaignFormData.retail_value
                                                  .value.min
                                              ) + 1
                                            : 1
                                        }
                                        value={
                                          campaignFormData?.retail_value?.value
                                            ?.max || ""
                                        }
                                        onChange={(e) => {
                                          handleOnChange("retail_value", {
                                            ...campaignFormData?.retail_value,
                                            value: {
                                              ...campaignFormData?.retail_value
                                                ?.value,
                                              max: e.target.value,
                                            },
                                          });
                                        }}
                                      />
                                    </InputGroup>
                                    {/* Warning message for max value */}
                                    {campaignFormData?.retail_value?.value
                                      ?.max &&
                                      campaignFormData?.retail_value?.value
                                        ?.min &&
                                      parseFloat(
                                        campaignFormData.retail_value.value.max
                                      ) <=
                                        parseFloat(
                                          campaignFormData.retail_value.value
                                            .min
                                        ) && (
                                        <div
                                          className="text-danger mt-1"
                                          style={{ fontSize: "12px" }}
                                        >
                                          Max value must be greater than min
                                          value
                                        </div>
                                      )}
                                  </Form.Group>
                                </div>
                              )}
                            </Form>
                          </div>
                          {/* credit card box */}
                          <div className="CCcard-box">
                            <div className="head">
                              <a
                                data-tooltip-id="tooltip"
                                data-tooltip-content="Request to place a hold on the creator's credit card for the value of the product you are shipping to them. This may limit the amount of opt-ins you receive for this campaign. This is not a guarantee, but will ensure creators are held accountable and more likely to post on time."
                              >
                                <BsFillInfoCircleFill />
                              </a>
                              <Tooltip id="tooltip" place="top" />
                              <h6>Credit Card Hold</h6>
                            </div>
                            <div key={"checkbox"} className="mb-3 mt-2">
                              <Form.Check
                                type="checkbox"
                                label="Required"
                                checked={
                                  campaignFormData?.creditCardHold ?? false
                                }
                                onChange={(e) =>
                                  handleOnChange(
                                    "creditCardHold",
                                    e.target.checked
                                  )
                                }
                              />
                            </div>
                          </div>
                          {/* paid box  */}
                          <div className="paid-box">
                            <div className="head">
                              <a
                                data-tooltip-id="tooltip"
                                data-tooltip-content="If you are paying the creator in addition to product, please indicate that here. We recommend $150 in payment for every 10k followers."
                              >
                                <BsFillInfoCircleFill />
                              </a>
                              <Tooltip id="tooltip" place="top" />
                              <h6>Paid Campaign</h6>
                            </div>
                            <div key={"checkbox"} className="mb-3 mt-2">
                              <Form.Check
                                type={"Checkbox"}
                                label={"Creator will also be provided payment"}
                                className=""
                                checked={
                                  campaignFormData?.paid_campaign_payment ??
                                  false
                                }
                                onClick={() =>
                                  handleOnChange(
                                    "paid_campaign_payment",
                                    !campaignFormData?.paid_campaign_payment ??
                                      false
                                  )
                                }
                              />
                            </div>
                            {/* payment */}
                            {campaignFormData?.paid_campaign_payment && (
                              <div className="paymentBox">
                                <h6>Payment</h6>
                                <Form>
                                  <Form.Check
                                    type="radio"
                                    id="fixedPayment"
                                    name="priceType"
                                    label="Fixed"
                                    checked={
                                      campaignFormData?.paid_campaign_payment
                                        ?.type === "fixed"
                                    }
                                    onChange={() => {
                                      handleOnChange("paid_campaign_payment", {
                                        ...campaignFormData?.paid_campaign_payment,
                                        type: "fixed",
                                        value: "",
                                      });
                                    }}
                                  />
                                  <Form.Check
                                    type="radio"
                                    id="range"
                                    name="priceType"
                                    label="Range"
                                    checked={
                                      campaignFormData?.paid_campaign_payment
                                        ?.type === "range"
                                    }
                                    onChange={() => {
                                      handleOnChange("paid_campaign_payment", {
                                        ...campaignFormData?.paid_campaign_payment,
                                        type: "range",
                                        value: {},
                                      });
                                    }}
                                  />
                                  {campaignFormData?.paid_campaign_payment
                                    ?.type === "fixed" ? (
                                    <Form.Group
                                      controlId="formFixed67Value"
                                      className="mt-2"
                                    >
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <FormControl
                                          type="number"
                                          value={
                                            campaignFormData
                                              ?.paid_campaign_payment?.value ||
                                            ""
                                          }
                                          onChange={(e) => {
                                            handleOnChange(
                                              "paid_campaign_payment",
                                              {
                                                ...campaignFormData?.paid_campaign_payment,
                                                value: e.target.value,
                                              }
                                            );
                                          }}
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  ) : (
                                    <div className=" mt-2 range-input">
                                      <Form.Group controlId="formRangeMinValue">
                                        <InputGroup>
                                          <InputGroup.Text>
                                            Min $
                                          </InputGroup.Text>
                                          <FormControl
                                            type="number"
                                            min="0"
                                            value={
                                              campaignFormData
                                                ?.paid_campaign_payment?.value
                                                ?.min || ""
                                            }
                                            onChange={(e) => {
                                              handleOnChange(
                                                "paid_campaign_payment",
                                                {
                                                  ...campaignFormData?.paid_campaign_payment,
                                                  value: {
                                                    ...campaignFormData
                                                      ?.paid_campaign_payment
                                                      ?.value,
                                                    min: e.target.value,
                                                  },
                                                }
                                              );
                                            }}
                                          />
                                        </InputGroup>
                                      </Form.Group>
                                      <Form.Group
                                        controlId="formRangeMaxValue"
                                        className=""
                                      >
                                        <InputGroup>
                                          <InputGroup.Text>
                                            Max $
                                          </InputGroup.Text>
                                          <FormControl
                                            type="number"
                                            min={
                                              campaignFormData
                                                ?.paid_campaign_payment?.value
                                                ?.min
                                                ? parseFloat(
                                                    campaignFormData
                                                      .paid_campaign_payment
                                                      .value.min
                                                  ) + 1
                                                : 1
                                            }
                                            value={
                                              campaignFormData
                                                ?.paid_campaign_payment?.value
                                                ?.max || ""
                                            }
                                            onChange={(e) => {
                                              handleOnChange(
                                                "paid_campaign_payment",
                                                {
                                                  ...campaignFormData?.paid_campaign_payment,
                                                  value: {
                                                    ...campaignFormData
                                                      ?.paid_campaign_payment
                                                      ?.value,
                                                    max: e.target.value,
                                                  },
                                                }
                                              );
                                            }}
                                          />
                                        </InputGroup>
                                        {/* Warning message for max value */}
                                        {campaignFormData?.paid_campaign_payment
                                          ?.value?.max &&
                                          campaignFormData
                                            ?.paid_campaign_payment?.value
                                            ?.min &&
                                          parseFloat(
                                            campaignFormData
                                              .paid_campaign_payment.value.max
                                          ) <=
                                            parseFloat(
                                              campaignFormData
                                                .paid_campaign_payment.value.min
                                            ) && (
                                            <div
                                              className="text-danger mt-1"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Max payment must be greater than
                                              min payment
                                            </div>
                                          )}
                                      </Form.Group>
                                    </div>
                                  )}
                                </Form>
                              </div>
                            )}
                          </div>
                          {/* age restrictions box */}
                          <div className="age-box">
                            <div className="head">
                              <h6>Age Restrictions</h6>
                            </div>
                            <div key={"checkbox"} className="mb-3 mt-2">
                              <Form.Check
                                type={"Checkbox"}
                                label={"This product contains alcohol"}
                                checked={
                                  campaignFormData?.age_restriction?.includes(
                                    "Alcohol"
                                  ) || false
                                }
                                className=""
                                onClick={(e) => {
                                  const isChecked = e.target.checked;
                                  const updatedRestrictions = isChecked
                                    ? [
                                        ...(campaignFormData?.age_restriction ||
                                          []),
                                        "Alcohol",
                                      ]
                                    : campaignFormData?.age_restriction?.filter(
                                        (item) => item !== "Alcohol"
                                      );
                                  handleOnChange(
                                    "age_restriction",
                                    updatedRestrictions
                                  );
                                }}
                              />
                              <Form.Check
                                type={"Checkbox"}
                                label={"This product contains cannabis"}
                                className=""
                                checked={
                                  campaignFormData?.age_restriction?.includes(
                                    "Cannabis"
                                  ) || false
                                }
                                onClick={(e) => {
                                  const isChecked = e.target.checked;
                                  const updatedRestrictions = isChecked
                                    ? [
                                        ...(campaignFormData?.age_restriction ||
                                          []),
                                        "Cannabis",
                                      ]
                                    : campaignFormData?.age_restriction?.filter(
                                        (item) => item !== "Cannabis"
                                      );

                                  handleOnChange(
                                    "age_restriction",
                                    updatedRestrictions
                                  );
                                }}
                              />
                            </div>
                          </div>
                          {/* product description */}
                          <div className="product-desc-box">
                            <div className="head-detail">
                              <h6>Product Description</h6>
                              <p>
                                In 1-2 sentences, describe what the creator will
                                receive from you.
                              </p>
                            </div>
                            <Form.Control
                              as="textarea"
                              placeholder=""
                              style={{ height: "120px" }}
                              value={
                                campaignFormData?.product_description || ""
                              }
                              onChange={(e) =>
                                handleOnChange(
                                  "product_description",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          {/* campaign description */}
                          <div className="campagin-desc-box">
                            <div className="head-detail">
                              <h6>Campaign Description</h6>
                              <p>
                                In 1-2 sentences, describe what the creator will
                                receive from you.
                              </p>
                            </div>
                            <Form.Control
                              as="textarea"
                              style={{ height: "120px" }}
                              value={campaignFormData?.description || ""}
                              onChange={(e) =>
                                handleOnChange("description", e.target.value)
                              }
                            />
                          </div>
                          {/* whats to do */}
                          <div className="campagin-desc-box">
                            <div className="head-detail">
                              <h6>Campaign Guidelines – What to Do</h6>
                              <p>
                                In 1-2 sentences, describe what the creator will
                                receive from you.
                              </p>
                            </div>
                            <Form.Control
                              as="textarea"
                              style={{ height: "120px" }}
                              value={campaignFormData?.what_to || ""}
                              onChange={(e) =>
                                handleOnChange("what_to", e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  const textarea = e.target;
                                  const currentValue = textarea.value;
                                  const cursorPosition =
                                    textarea.selectionStart;
                                  const textBeforeCursor =
                                    currentValue.substring(0, cursorPosition);
                                  const textAfterCursor =
                                    currentValue.substring(cursorPosition);
                                  const newText =
                                    textBeforeCursor +
                                    "\n💥 " +
                                    textAfterCursor;
                                  textarea.value = newText;
                                  handleOnChange("what_to", newText);
                                  setTimeout(() => {
                                    const newCursorPosition =
                                      cursorPosition + 3;
                                    textarea.selectionStart = newCursorPosition;
                                    textarea.selectionEnd = newCursorPosition;
                                  }, 0);
                                }
                              }}
                              onFocus={(e) => {
                                if (!campaignFormData?.what_to?.trim()) {
                                  const textarea = e.target;
                                  textarea.value = "💥 ";
                                  handleOnChange("what_to", "💥 ");
                                }
                              }}
                            />
                          </div>
                          {/* whats not */}
                          <div className="campagin-desc-box">
                            <div className="head-detail">
                              <h6>Campaign Guidelines – What Not to Do</h6>
                              <p>
                                In 1-2 sentences, describe what the creator will
                                receive from you.
                              </p>
                            </div>
                            <Form.Control
                              as="textarea"
                              style={{ height: "120px" }}
                              value={campaignFormData?.what_not_to || ""}
                              onChange={(e) =>
                                handleOnChange("what_not_to", e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  const textarea = e.target;
                                  const currentValue = textarea.value;
                                  const cursorPosition =
                                    textarea.selectionStart;
                                  const textBeforeCursor =
                                    currentValue.substring(0, cursorPosition);
                                  const textAfterCursor =
                                    currentValue.substring(cursorPosition);
                                  const newText =
                                    textBeforeCursor +
                                    "\n💥 " +
                                    textAfterCursor;
                                  textarea.value = newText;
                                  handleOnChange("what_not_to", newText);
                                  setTimeout(() => {
                                    const newCursorPosition =
                                      cursorPosition + 3;
                                    textarea.selectionStart = newCursorPosition;
                                    textarea.selectionEnd = newCursorPosition;
                                  }, 0);
                                }
                              }}
                              onFocus={(e) => {
                                if (!campaignFormData?.what_not_to?.trim()) {
                                  const textarea = e.target;
                                  textarea.value = "💥 ";
                                  handleOnChange("what_not_to", "💥 ");
                                }
                              }}
                            />
                          </div>
                          {/* hero image */}
                          <div className="hero-img-box">
                            <div className="head-detail">
                              <h6>Hero Images</h6>
                              <Uploader
                                listType="picture"
                                maxCount={1}
                                disabled={!!fileInfo}
                                multiple={false}
                                accept="image/*"
                                action={ApiUrl.uploadLogo}
                                method="POST"
                                data={{ folder: "campaign" }}
                                className="mt-1 hero-image-upload"
                                defaultFileList={
                                  fileInfo ? [fileInfo] : heroDefaultFileList
                                }
                                onUpload={(file) => {
                                  const blobUrl = URL.createObjectURL(
                                    file.blobFile
                                  );
                                  setHeroPreview(blobUrl);
                                  setFileInfo({
                                    name: file.name,
                                    fileKey: file.fileKey,
                                    url: blobUrl,
                                    status: "inited",
                                  });
                                }}
                                onSuccess={(response, file) => {
                                  handleHeroUpload({
                                    file: response?.file,
                                    key: file?.fileKey,
                                  });

                                  setFileInfo({
                                    name: file.name,
                                    fileKey: file.fileKey,
                                    url: heroPreview,
                                    status: "finished",
                                  });
                                }}
                                onRemove={() => onRemoveHeroFile()}
                                onError={() => setFileInfo(null)}
                              >
                                <button>
                                  <BsUpload />
                                  Upload Hero Image
                                </button>
                              </Uploader>
                            </div>
                          </div>
                          {/* gallery */}
                          <div className="gallery-img-box">
                            <div className="head-detail">
                              <h6>Gallery Images</h6>
                              <p>
                                We recommend uploading a minimum of 3 gallery
                                images or videos. For best results, make sure
                                the images are at a 1:1 (square) aspect ratio.
                              </p>
                              <Uploader
                                multiple
                                listType="picture"
                                accept="image/*"
                                defaultFileList={galleryDefaultFileList}
                                data={{ folder: "campaign/gallery" }}
                                method={"POST"}
                                className="gallery-img-upload"
                                action={ApiUrl.uploadLogo}
                                onSuccess={(response, file) => {
                                  onGallerySuccess(response, file);
                                }}
                                onUpload={(file) => {
                                  if (file?.blobFile) {
                                    previewFile(file.blobFile, (dataUrl) => {
                                      setFileInfo({
                                        name: file.name,
                                        fileKey: file.fileKey,
                                        preview: dataUrl,
                                        status: "uploading",
                                      });
                                    });
                                  }
                                }}
                                onError={() => {
                                  setFileInfo(null);
                                }}
                                onRemove={(file) => {
                                  onRemoveGalleryFile(file);
                                }}
                              >
                                <button>
                                  <BsCloudUploadFill />
                                  <span> Upload files here</span>
                                  <span> Browse From Your Device</span>
                                </button>
                              </Uploader>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*requirnment-box  */}
                      <div ref={requirnment} className="requirnment-box box">
                        <h4 className="section-heading">Requirements</h4>
                        <p>
                          Set requirements for the type of creators you would
                          like to have for this campaign.
                        </p>
                        <div className="inner-content">
                          {/* age-box */}
                          <div className="age-range-box">
                            <h6>
                              Age range
                              <span> (optional, default is 13+)</span>
                            </h6>
                            <div className=" mt-2 range-input">
                              <InputGroup>
                                <FormControl
                                  type="number"
                                  min="0"
                                  placeholder="Min"
                                  value={campaignFormData?.age?.min || ""}
                                  onChange={(e) =>
                                    handleOnChange("age", {
                                      ...campaignFormData.age,
                                      min: e.target.value,
                                    })
                                  }
                                />
                              </InputGroup>
                              <InputGroup>
                                <FormControl
                                  type="number"
                                  placeholder="Max"
                                  min={
                                    campaignFormData?.age?.min
                                      ? parseInt(campaignFormData.age.min) + 1
                                      : 1
                                  }
                                  value={campaignFormData?.age?.max}
                                  onChange={(e) =>
                                    handleOnChange("age", {
                                      ...campaignFormData.age,
                                      max: e.target.value,
                                    })
                                  }
                                />
                              </InputGroup>
                              {/* Warning message */}
                            </div>
                            {campaignFormData?.age?.max &&
                              campaignFormData?.age?.min &&
                              parseInt(campaignFormData.age.max) <=
                                parseInt(campaignFormData.age.min) && (
                                <div
                                  className="text-danger mt-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  Max age must be greater than min age
                                </div>
                              )}
                          </div>
                          {/* gender-box */}
                          <div className="gender-box">
                            <div className="head">
                              <h6>
                                Genders <span>(select all that apply)</span>
                              </h6>
                            </div>

                            <div key={"checkbox"}>
                              {campaignData?.genderTypes?.map((item, index) => (
                                <Form.Check
                                  key={`gender-${index}`}
                                  type="checkbox"
                                  label={item.name}
                                  checked={
                                    campaignFormData?.gender?.includes(
                                      item.name
                                    ) || false
                                  }
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;

                                    const updatedGenders = isChecked
                                      ? [
                                          ...(campaignFormData?.gender || []),
                                          item.name,
                                        ]
                                      : campaignFormData?.gender?.filter(
                                          (val) => val !== item.name
                                        );
                                    handleOnChange("gender", updatedGenders);
                                  }}
                                />
                              ))}
                            </div>
                          </div>
                          {/*countries-box */}
                          <div className="countries-box">
                            <h6>Country</h6>
                            <Select
                              options={campaignData?.loactions?.map((item) => ({
                                label: item.name,
                                value: item.id,
                                ...item,
                              }))}
                              placeholder="Select"
                              styles={customStyles}
                              isMulti
                              components={{
                                MultiValue: IconSingleValueCountry,
                                Option: CountryOption,
                              }}
                              value={
                                campaignData?.loactions
                                  ?.filter((option) =>
                                    campaignFormData?.location_id?.includes(
                                      option.id
                                    )
                                  )
                                  .map((item) => ({
                                    label: item.name,
                                    value: item.id,
                                    ...item,
                                  })) || []
                              }
                              onChange={(selectedOptions) =>
                                handleOnChange(
                                  "location_id",
                                  selectedOptions.map((option) => option.value)
                                )
                              }
                            />
                          </div>
                          {/* niche-box*/}
                          <div className="niche-box">
                            <h6>
                              Niches <span>(areas of influence)</span>
                            </h6>
                            <Select
                              options={campaignData?.categories_list}
                              placeholder="Niche"
                              styles={customStyles}
                              isMulti
                              value={selectedCategories}
                              onChange={(selectedOptions) => {
                                setSelectedCategories(selectedOptions);
                                handleOnChange(
                                  "category_id",
                                  selectedOptions?.map((option) => option.value)
                                );
                              }}
                            />
                          </div>
                          {/* engagement-box */}
                          {campaignFormData?.campaign_strategy !== 1 &&
                            campaignFormData?.campaign_platform?.map(
                              (item, index) => (
                                <div
                                  className="engagement-box"
                                  key={`social-platform-${index}`}
                                >
                                  <h6>
                                    <img
                                      src={getSocialPlatform(item.id)?.icon}
                                      alt="Platform Icon"
                                    />
                                    {item?.name}
                                  </h6>
                                  <div className="mt-2 follower-range-input">
                                    <Form.Group controlId="formRangeMinValue">
                                      <Form.Label>Followers</Form.Label>
                                      <FormControl
                                        type="number"
                                        label="Followers"
                                        value={
                                          item?.social_engagement_data
                                            ?.follower || ""
                                        }
                                        onChange={(e) => {
                                          const campaign_platforms = [
                                            ...campaignFormData?.campaign_platform,
                                          ];
                                          campaign_platforms[
                                            index
                                          ].social_engagement_data.follower =
                                            e.target.value;
                                          handleOnChange(
                                            "campaign_platform",
                                            campaign_platforms
                                          );
                                        }}
                                      />
                                    </Form.Group>
                                    <Form.Group controlId="formRangeMaxValue">
                                      <Form.Label>Engagement</Form.Label>
                                      <FormControl
                                        type="number"
                                        label="Engagement"
                                        value={
                                          item?.social_engagement_data
                                            ?.engagement || ""
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value
                                            .replace(/\D/g, "")
                                            .slice(0, 2);
                                          const campaign_platforms = [
                                            ...campaignFormData?.campaign_platform,
                                          ];
                                          campaign_platforms[
                                            index
                                          ].social_engagement_data.engagement =
                                            value;
                                          // campaign_platforms[
                                          //   index
                                          // ].social_engagement_data.engagement =
                                          //   e.target.value;
                                          handleOnChange(
                                            "campaign_platform",
                                            campaign_platforms
                                          );
                                        }}
                                      />
                                    </Form.Group>
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                      {/*deliverables-box  */}
                      <div ref={deliverables} className="deliverables-box box">
                        <h4 className="section-heading">Deliverables</h4>
                        <p>
                          Provide guidance on the type and quality of content
                          you would like from creators for this campaign.
                        </p>
                        <div className="inner-content">
                          {/* content-format */}
                          {campaignFormData?.campaign_strategy !== 1 && (
                            <div className="content-formats-box">
                              <h6>Content-Formats</h6>
                              <p>
                                Provide a visual description or theme for how
                                the creator's content should look and feel.
                              </p>
                              <div className=" mt-3 content-range-input">
                                <FormControl
                                  type="number"
                                  min="0"
                                  value={contentFormatCounts?.video}
                                  onChange={(e) =>
                                    setContentFormatCounts({
                                      ...contentFormatCounts,
                                      video: e.target.value,
                                    })
                                  }
                                />
                                <div className="img-section">
                                  {getSocialPlatformbyName("instagram") && (
                                    <img
                                      src={Images.instagram}
                                      alt="instagram"
                                    />
                                  )}
                                  {getSocialPlatformbyName("youtube") && (
                                    <img src={Images.youtube} alt="youtube" />
                                  )}
                                  {getSocialPlatformbyName("tiktok") && (
                                    <img src={Images.tikTok} alt="tik-tok" />
                                  )}
                                  <span>Video</span>
                                </div>
                              </div>
                              {/* shorts */}
                              {getSocialPlatformbyName("youtube") && (
                                <div className=" mt-3 content-range-input">
                                  <FormControl
                                    type="number"
                                    min="0"
                                    value={contentFormatCounts?.shorts}
                                    onChange={(e) =>
                                      setContentFormatCounts({
                                        ...contentFormatCounts,
                                        shorts: e.target.value,
                                      })
                                    }
                                  />
                                  <div className="img-section">
                                    <img src={Images.youtube} alt="youtube" />
                                    <span>Shorts</span>
                                  </div>
                                </div>
                              )}
                              {getSocialPlatformbyName("Instagram") && (
                                <>
                                  {/* story */}
                                  <div className=" mt-3 content-range-input">
                                    <FormControl
                                      type="number"
                                      min="0"
                                      value={contentFormatCounts?.story}
                                      onChange={(e) =>
                                        setContentFormatCounts({
                                          ...contentFormatCounts,
                                          story: e.target.value,
                                        })
                                      }
                                    />
                                    <div className="img-section">
                                      <img
                                        src={Images.instagram}
                                        alt="instagram"
                                      />
                                      <span>Story</span>
                                    </div>
                                  </div>
                                  {/* IGTV */}
                                  <div className=" mt-3 content-range-input">
                                    <FormControl
                                      type="number"
                                      min="0"
                                      value={contentFormatCounts?.igtv}
                                      onChange={(e) =>
                                        setContentFormatCounts({
                                          ...contentFormatCounts,
                                          igtv: e.target.value,
                                        })
                                      }
                                    />
                                    <div className="img-section">
                                      <img
                                        src={Images.instagram}
                                        alt="instagram"
                                      />
                                      <span>IGTV</span>
                                    </div>
                                  </div>
                                  {/* reel */}
                                  <div className=" mt-3 content-range-input">
                                    <FormControl
                                      type="number"
                                      min="0"
                                      value={contentFormatCounts?.reel}
                                      onChange={(e) =>
                                        setContentFormatCounts({
                                          ...contentFormatCounts,
                                          reel: e.target.value,
                                        })
                                      }
                                    />
                                    <div className="img-section">
                                      <img
                                        src={Images.instagram}
                                        alt="instagram"
                                      />
                                      <span>Reel</span>
                                    </div>
                                  </div>
                                  {/* post */}
                                  <div className=" mt-3 content-range-input">
                                    <FormControl
                                      type="number"
                                      min="0"
                                      value={contentFormatCounts?.post}
                                      onChange={(e) =>
                                        setContentFormatCounts({
                                          ...contentFormatCounts,
                                          post: e.target.value,
                                        })
                                      }
                                    />
                                    <div className="img-section">
                                      <img
                                        src={Images.instagram}
                                        alt="instagram"
                                      />
                                      <span>Post</span>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                          {/* inspiration-box */}
                          <div className="inspiration-box">
                            <h6>Inspiration Board</h6>
                            <p>
                              Include images or videos you would like to use to
                              inspire your creator's artistic direction. For
                              best results, make sure the images are at a 1:1
                              (square) aspect ratio.
                            </p>
                            <Uploader
                              multiple
                              listType="picture"
                              accept="video/*,image/*"
                              action={ApiUrl.uploadLogo}
                              data={{ folder: "campaign/inspiration" }}
                              className="insprition-img-upload"
                              method="POST"
                              defaultFileList={inspirationDefaultList}
                              onSuccess={(response, file) =>
                                onInspirationSuccess(response, file)
                              }
                              onRemove={(file) => onRemoveInspirationFile(file)}
                              onUpload={(file) => {
                                if (file?.blobFile) {
                                  previewFile(file.blobFile, (dataUrl) => {
                                    setFileInfo({
                                      name: file.name,
                                      fileKey: file.fileKey,
                                      preview: dataUrl,
                                      status: "uploading",
                                    });
                                  });
                                }
                              }}
                              onError={() => setFileInfo(null)}
                            >
                              <button>
                                <BsCloudUploadFill />
                                <span> Drag files here</span>
                                <span> or Browse From Your Device</span>
                              </button>
                            </Uploader>
                          </div>
                          {/* visuals-box */}
                          <div className="visuals-box">
                            <h6>Visuals & Theme</h6>
                            <p>
                              Provide a visual description or theme for how the
                              creator's content should look and feel.
                            </p>
                            <Form.Control
                              as="textarea"
                              style={{ height: "120px" }}
                              value={campaignFormData.visuals_theme ?? ""}
                              onChange={(e) =>
                                handleOnChange("visuals_theme", e.target.value)
                              }
                            />
                          </div>
                          {/* captions-box */}
                          <div className="captions-box">
                            <h6>Captions or Hashtags</h6>
                            <p>
                              Provide some guidance for what the creator's
                              caption should say. Remember the caption is an
                              important part of their identity. The more freedom
                              you allow, the more authentic the post will appear
                              to their followers.
                            </p>
                            <p>
                              <strong>
                                *TikTok captions have a character limit of 100,
                                including hashtags & spaces.
                              </strong>
                            </p>
                            <Form.Control
                              as="textarea"
                              placeholder="Type words starting with @ or # (e.g., @trending #viral @fashion)"
                              style={{ height: "120px" }}
                              value={campaignFormData?.caption ?? ""}
                              onKeyDown={(e) => {
                                const textarea = e.target;
                                const cursorPosition = textarea.selectionStart;
                                const currentValue = textarea.value;
                                if (
                                  e.key.length > 1 ||
                                  e.ctrlKey ||
                                  e.metaKey ||
                                  e.key === " " ||
                                  e.key === "@" ||
                                  e.key === "#"
                                ) {
                                  return;
                                }
                                let wordStart = cursorPosition;
                                while (
                                  wordStart > 0 &&
                                  currentValue[wordStart - 1] !== " "
                                ) {
                                  wordStart--;
                                }
                                const firstChar = currentValue[wordStart];
                                if (firstChar !== "@" && firstChar !== "#") {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) =>
                                handleOnChange("caption", e.target.value)
                              }
                            />
                          </div>
                          {/* hashtag-box */}
                          {/* <div className="hashtag-box">
                            <h6>Content Capture Tags</h6>
                            <p>
                              We use hashtags and mentions to capture content
                              created for your campaigns, so be sure these are
                              unique to each campaign.
                            </p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="campagin-view-wrapper">
                    <div className="submit-btn">
                      <Button onClick={() => handleSubmit()}>
                        <BsUpload />
                        Submit For Review
                      </Button>
                    </div>
                    <div className="campagin-view-inner">
                      <div className="tab-list">
                        <ul>
                          <li
                            className={activeMenu === general ? "active" : ""}
                            onClick={() => scrollToSection(general)}
                          >
                            General
                          </li>
                          <li
                            className={
                              activeMenu === compensation ? "active" : ""
                            }
                            onClick={() => scrollToSection(compensation)}
                          >
                            Compensation
                          </li>
                          <li
                            className={
                              activeMenu === requirnment ? "active" : ""
                            }
                            onClick={() => scrollToSection(requirnment)}
                          >
                            Requirements
                          </li>
                          <li
                            className={
                              activeMenu === deliverables ? "active" : ""
                            }
                            onClick={() => scrollToSection(deliverables)}
                          >
                            Deliverables
                          </li>
                        </ul>
                      </div>
                      {/* product draft */}
                      <div className="draft-card-wrapper">
                        <div className="draft-card">
                          <h6 className="company">
                            {auth?.user?.company_name}
                          </h6>
                          <h6>
                            {campaignFormData?.campaign_title
                              ? campaignFormData?.campaign_title
                              : "Campaign Title"}
                          </h6>
                          <div className="img-box">
                            {heroPreview ? (
                              <img src={heroPreview} alt="preview" />
                            ) : (
                              campaignFormData?.hero_image && (
                                <img
                                  src={campaignFormData.hero_image}
                                  alt="preview"
                                />
                              )
                            )}
                          </div>
                          <div className="content-box">
                            <div className="followers common-box">
                              <span>followers</span>
                              <span className="data">{summary?.follower}</span>
                            </div>
                            <div className="Engagement common-box">
                              <span>Engagement</span>
                              <span className="data">
                                {summary?.engagement}
                              </span>
                            </div>
                            <div className="Age common-box">
                              <span>Age</span>
                              <span className="data">{summary?.age}</span>
                            </div>
                            <div className="Residence common-box">
                              <span>Residence</span>
                              <span className="data">{summary?.countries}</span>
                            </div>
                            <p className="diabled-btn">
                              {summary?.niche !== "-"
                                ? summary.niche
                                : "Any niche"}
                            </p>
                            {/* <div className="strategy-channel">
                              <img src={Images.speaker} alt="strategy" />
                              <img src={Images.instagram} alt="channel" />
                            </div> */}
                          </div>
                          <p className="tag">Draft Campaign</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
};

export default EditCampign;
